<template>
  <div class="tab-wear-like-this">
    <RemoveWearLikeThisImageModal />

    <uppload
      v-model="url"
      :uploader="customUploader"
      v-if="currentUser !== null"
    >
      <img alt="" class="uppload-image" />
      <button class="btn add-outfit-btn float-right" ref="uploadImageBtn">
        Add your outfit
      </button>
    </uppload>

    <button
      class="btn add-outfit-btn float-right"
      ref="uploadImageBtn"
      @click="showSingIn()"
      v-else
    >
      Add your outfit
    </button>

    <masonry
      :cols="{ default: 3, 1000: 2, 700: 2, 400: 1 }"
      :gutter="{ default: '30px', 700: '15px' }"
      v-if="hasWearLikeThisImages"
    >
      <div v-for="entry in wearLikeThisImages" :key="entry.id" class="item">
        <img class="img-fluid" :src="entry.file.url" />
        <i
          class="action-icon pe-7s-trash"
          @click="showRemoveWearLikeThisImageModal(entry)"
          v-if="imageBelongsToUser(entry.user_id)"
        ></i>
      </div>
    </masonry>

    <div v-else>
      <WearLikeThisEmptyState />
    </div>
  </div>
</template>

<script>
import WearLikeThisEmptyState from "@/components/showCapsule/tabs/emptyStates/WearLikeThisEmptyState";
import RemoveWearLikeThisImageModal from "@/components/showCapsule/modals/RemoveWearLikeThisImageModal";
import Uppload from "@/components/showCapsule/Uppload.vue";
import { mapGetters, mapActions } from "vuex";
import { bus } from "@/main";

export default {
  mounted() {
    this.fetchWearLikeThisImages({ capsuleId: this.currentCapsule.id });
  },

  components: {
    RemoveWearLikeThisImageModal,
    WearLikeThisEmptyState,
    Uppload,
  },

  data() {
    return {
      url: null,
    };
  },

  methods: {
    ...mapActions(["fetchWearLikeThisImages", "createWearLikeThisImage"]),

    showRemoveWearLikeThisImageModal(wearLikeThisImage) {
      this.$nextTick(() => {
        this.$modal.show("confirm-remove-wear-like-this-image", {
          wearLikeThisImage: wearLikeThisImage,
        });
      });
    },

    imageBelongsToUser(userId) {
      return this.currentUser && this.currentUser.id === userId;
    },

    showSingIn() {
      bus.$emit("openSignUpModal");
    },

    customUploader(file, updateProgress) {
      return new Promise((resolve) => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("capsule_id", this.currentCapsule.id);

        this.createWearLikeThisImage(formData).then((resp) => {
          resolve(resp.file_url);
        });

        let progress = 0;
        const interval = setInterval(() => {
          if (progress > 99) clearInterval(interval);
          updateProgress(progress++);
        }, 25);
      });
    },
  },

  computed: {
    ...mapGetters(["currentCapsule", "currentUser", "wearLikeThisImages"]),

    hasWearLikeThisImages() {
      return this.wearLikeThisImages.length > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";
.tab-wear-like-this {
  .item {
    background: #fff;
    border-top: 1px solid #ffffff;
    border-radius: 0.3em !important;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    margin-bottom: 30px;
    padding: 15px;
    text-align: right;
    transition: 1s ease all;

    &:hover {
      border-top: 1px solid #f2f2f2;
      box-shadow: 0px 5px 5px 0px rgba(169, 169, 169, 1);
    }

    img {
      min-width: 100%;
    }

    .action-icon {
      cursor: pointer;
      color: $primary-blue;
      font-size: 1.2rem;
      margin-top: 15px;
      padding: 10px;

      &.active {
        color: $primary-accent;
      }

      &:hover {
        background-color: rgba(158, 158, 158, 0.2);
        border-radius: 50%;
      }
      &:active {
        background-color: rgba(158, 158, 158, 0.4);
      }
    }
  }
  .item--small {
    margin-bottom: 10px;
  }

  .add-outfit-btn {
    background-color: $grey5;
    font-size: 11px;
    margin-top: -35px;

    &:hover,
    &:active {
      box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14);
    }

    &:focus {
      box-shadow: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/showCapsule/tabs/WearLikeThisTab.vue